import React, { useState, useRef } from 'react';
import './PlantGallery.scss';

const productsEn = [
  {
    id: 1,
    name: 'ABC Juice Shot',
    volume: '100ml Shot',
    focus: 'Blood, Glow & Stamina',
    emoji: '🔴',
    accent: '#c0392b',
    accentLight: '#fdf2f2',
    accentBorder: '#f5c6c6',
    image: '/ABC_Juice_1.png',
    points: [
      { title: 'Natural Hemoglobin Support', desc: 'Beetroot provides bio-available iron to naturally boost red blood cell counts.' },
      { title: 'Nitric Oxide Engine', desc: 'Increases blood flow, helping oxygen reach your brain and muscles faster.' },
      { title: 'Pre-Workout Fuel', desc: 'Enhances athletic endurance by reducing the oxygen cost of exercise.' },
      { title: 'Liver Detoxification', desc: 'Contains betalains that help the liver neutralize and flush out metabolic toxins.' },
      { title: 'Skin Radiance', desc: 'High Vitamin C and antioxidants target internal heat to clear skin and add a natural glow.' },
      { title: 'Blood Purification', desc: 'Acts as a natural internal filter, supporting clean and healthy circulation.' },
      { title: 'B-Complex Rich', desc: 'Essential for cellular DNA repair and consistent daily energy levels.' },
      { title: 'Eye Health', desc: 'Carotenoids from organic carrots support long-term vision and retinal health.' },
      { title: 'Zero-Sugar Vitality', desc: 'Pure vegetable energy with no insulin spikes or crashes.' },
    ],
  },
  {
    id: 2,
    name: 'The Golden Cube',
    volume: '100ml Shot',
    focus: 'Joint Health, Recovery & Immunity',
    emoji: '🟡',
    accent: '#d4a017',
    accentLight: '#fffbf0',
    accentBorder: '#fde9a0',
    image: '/The_Golden_Cube_1.png',
    points: [
      { title: 'Curcumin Activation', desc: "Turmeric's curcumin is made 5x more absorbable through our natural preparation process." },
      { title: 'Natural Anti-Inflammatory', desc: 'Physically blocks the enzymes that cause joint pain and body swelling.' },
      { title: 'Muscle Recovery', desc: 'Speeds up the repair of tissues after heavy physical work or gym sessions.' },
      { title: 'Immune System Primer', desc: 'Activates white blood cells to create a shield against seasonal infections.' },
      { title: 'Piperine Synergy', desc: 'Infused with black pepper to increase turmeric absorption by 2,000%.' },
      { title: 'Gut Lining Repair', desc: 'Soothes the digestive tract and helps repair leaky gut issues.' },
      { title: 'Brain Health', desc: 'Supports the production of brain-derived proteins that improve memory and focus.' },
      { title: 'Lymphatic Drainage', desc: 'Stimulates the movement of lymph fluids to reduce water retention.' },
      { title: 'Antibacterial Shield', desc: 'Acts as a natural internal cleanser to keep the gut environment healthy.' },
      { title: 'Trace Mineral Rich', desc: 'Our artisanal preparation process retains essential trace minerals in every golden drop.' },
    ],
  },
  {
    id: 3,
    name: 'The Fireball Shot',
    volume: '100ml Shot',
    focus: 'Metabolism, Heat & Congestion',
    emoji: '🔥',
    accent: '#e05c00',
    accentLight: '#fff5f0',
    accentBorder: '#ffd0b0',
    image: '/The_Fireball_Shot_1.png',
    points: [
      { title: 'Metabolic Ignition', desc: 'Triggers thermogenesis, helping the body burn calories more efficiently.' },
      { title: 'Instant Sinus Relief', desc: 'Ginger and cayenne heat instantly clear nasal and lung congestion.' },
      { title: 'Appetite Regulation', desc: 'Naturally suppresses sugar cravings and mid-day hunger pangs.' },
      { title: 'Adrenal Support', desc: 'Provides a sharp mental wake-up call without the jitters of caffeine.' },
      { title: 'Fat Oxidation', desc: 'Encourages the body to utilize stored fat as an active energy source.' },
      { title: 'Respiratory Strength', desc: 'Beneficial for those managing asthma or chronic cough by thinning mucus.' },
      { title: 'Healthy Circulation', desc: 'Rapidly stimulates blood flow to the extremities (hands and feet).' },
      { title: 'Digestive Fire (Agni)', desc: 'Ignites gastric enzymes to help digest heavy meals more effectively.' },
      { title: 'Endorphin Boost', desc: 'The natural spice triggers feel-good brain chemicals for a mood lift.' },
      { title: 'Antioxidant Surge', desc: 'Concentrated lemon and ginger provide a massive hit of Vitamin C.' },
    ],
  },
  {
    id: 4,
    name: 'The Glucose Guard',
    volume: '100ml Shot',
    focus: 'Blood Sugar, Pancreas & Bitter-Nutrition',
    emoji: '💚',
    accent: '#1a7a3c',
    accentLight: '#f0faf4',
    accentBorder: '#b2dfcc',
    image: '/The_Glucose_Guard_1.png',
    points: [
      { title: 'Insulin Mimicry', desc: 'Compounds in the Insulin Plant help cells absorb sugar from the blood naturally.' },
      { title: 'Sugar Absorption Blocker', desc: 'Bitter Gourd (Karela) prevents sugar receptors in the gut from over-absorbing glucose.' },
      { title: 'Pancreatic Support', desc: 'Helps reduce the workload on the pancreas by stabilizing blood sugar levels.' },
      { title: 'Moringa Super-Nutrition', desc: 'Provides more Calcium than milk and more Vitamin C than oranges in one shot.' },
      { title: 'Chlorophyll Detox', desc: 'Green blood molecules help flush heavy metals out of the human system.' },
      { title: 'Microgreen Potency', desc: 'Contains up to 40x more nutrients than mature vegetables for cellular repair.' },
      { title: 'Anti-Diabetic Tonic', desc: 'Traditionally designed to support Type-2 diabetes management.' },
      { title: 'Gut Microbiome Balance', desc: 'A natural ginger base ensures the bitter medicinal leaves are digested easily.' },
      { title: 'Hormonal Balance', desc: 'Supports the endocrine system to manage stress-induced sugar spikes.' },
      { title: 'Metabolic Defense', desc: "Strengthens the body's natural ability to manage carbohydrates." },
    ],
  },
  {
    id: 5,
    name: 'Ash Guard Juice',
    volume: '180ml / 250ml Juice',
    focus: 'pH Balance, Cooling & Hydration',
    emoji: '🩵',
    accent: '#0077a8',
    accentLight: '#f0f8fc',
    accentBorder: '#b0ddf0',
    image: '/Ash_Guard_1.png',
    points: [
      { title: 'Alkaline Fire Extinguisher', desc: 'One of the most alkaline foods on Earth; instantly neutralizes stomach acidity.' },
      { title: 'Cellular Hydration', desc: 'Holds water longer in the body than plain water, keeping you hydrated in the Hyderabad heat.' },
      { title: 'Internal Cooling', desc: 'Reduces Pitta or body heat that causes ulcers, rashes, and irritability.' },
      { title: 'Mental Clarity', desc: 'An Ayurvedic brain tonic that improves concentration and reduces anxiety.' },
      { title: 'Kidney Support', desc: 'Acts as a natural diuretic to flush out stones and prevent urinary infections.' },
      { title: 'Weight Management', desc: 'Extremely low in calories but very high in satiety, helping you feel full longer.' },
      { title: 'Stomach Lining Protection', desc: 'Coats and soothes the digestive tract to aid in healing ulcers.' },
      { title: 'Phlegm Clearance', desc: 'Helps clear excess mucus from the lungs and respiratory system.' },
      { title: 'Zinc & Mineral Rich', desc: 'Essential for skin repair, hair health, and immune defense.' },
      { title: 'Pure Vegetable Plasma', desc: '100% natural extraction with no added water, sugar, or chemicals.' },
    ],
  },
  {
    id: 6,
    name: 'Berry Banana Boost',
    volume: '180ml Smoothie',
    focus: 'Energy, Satiety & Brain Health',
    emoji: '🫐',
    accent: '#6a1b9a',
    accentLight: '#faf0ff',
    accentBorder: '#ddb8f5',
    image: '/Berry_Banana_Boost_1.png',
    points: [
      { title: 'Synbiotic Power', desc: 'Combines prebiotics (banana fiber) with probiotics for a super-gut fix.' },
      { title: 'Sustained Energy', desc: 'Provides complex carbohydrates for a steady release of energy without a crash.' },
      { title: 'Antioxidant Shield', desc: 'Forest berries provide anthocyanins to protect brain cells from oxidative stress.' },
      { title: 'Potassium Rich', desc: 'Supports healthy heart function and prevents muscle cramps.' },
      { title: 'Meal Replacement', desc: 'A thick, creamy texture that satisfies hunger for 2-3 hours naturally.' },
      { title: 'Digestion-Friendly', desc: '100% vegan and naturally prepared to prevent bloating.' },
      { title: 'Vitamin C Powerhouse', desc: 'Berries provide a massive boost to collagen production for healthy skin.' },
      { title: 'Mental Focus', desc: 'The combination of natural sugars and electrolytes keeps the brain sharp for students and professionals.' },
      { title: 'Zero Refined Sugar', desc: 'Entirely sweetened by organic, ripened fruit — no added sugar of any kind.' },
      { title: 'Post-Workout Recovery', desc: 'The perfect balance of minerals and anti-inflammatory berries to heal muscles.' },
    ],
  },
];

const productsEn_rest = productsEn.slice(1);

const rubyTe = {
  id: 1,
  name: 'ABC జ్యూస్ షాట్',
  volume: '100ml షాట్',
  focus: 'రక్తం, కాంతి & శక్తి',
  emoji: '🔴',
  accent: '#c0392b',
  accentLight: '#fdf2f2',
  accentBorder: '#f5c6c6',
  image: '/ABC_Juice_1.png',
  points: [
    { title: 'సహజ హిమోగ్లోబిన్ మద్దతు', desc: 'బీట్రూట్ లోని జీవ-అందుబాటు ఇనుము ఎర్ర రక్త కణాల సంఖ్యను సహజంగా పెంచుతుంది.' },
    { title: 'నైట్రిక్ ఆక్సైడ్ ఇంజిన్', desc: 'రక్త ప్రవాహాన్ని పెంచి, ఆక్సిజన్ మెదడు మరియు కండరాలకు వేగంగా చేరేలా చేస్తుంది.' },
    { title: 'వ్యాయామానికి ముందు ఇంధనం', desc: 'వ్యాయామంలో ఆక్సిజన్ వినియోగాన్ని తగ్గించి అథ్లెటిక్ సహనాన్ని పెంచుతుంది.' },
    { title: 'కాలేయ విషహరణ', desc: 'బెటాలైన్స్ కాలేయం విషపదార్థాలను తటస్థీకరించి బయటకు పంపడంలో సహాయపడతాయి.' },
    { title: 'చర్మ కాంతి', desc: 'విటమిన్ C మరియు యాంటీఆక్సిడెంట్లు అంతర్గత వేడిని తగ్గించి చర్మాన్ని స్వచ్ఛంగా మరియు ప్రకాశవంతంగా చేస్తాయి.' },
    { title: 'రక్త శుద్ధి', desc: 'సహజ అంతర్గత వడపోత వలె పనిచేసి, ఆరోగ్యకరమైన రక్త ప్రసరణకు మద్దతు ఇస్తుంది.' },
    { title: 'బి-కాంప్లెక్స్ సమృద్ధి', desc: 'కణ DNA మరమ్మత్తు మరియు నిరంతర శక్తి స్థాయిలకు అవసరం.' },
    { title: 'కంటి ఆరోగ్యం', desc: 'సేంద్రీయ క్యారెట్ల నుండి కెరోటినాయిడ్లు దీర్ఘకాలిక దృష్టి మరియు రెటీనా ఆరోగ్యానికి మద్దతు ఇస్తాయి.' },
    { title: 'జీరో-షుగర్ శక్తి', desc: 'ఇన్సులిన్ హెచ్చుతగ్గులు లేకుండా స్వచ్ఛమైన కూరగాయల శక్తి.' },
  ],
};

const goldenTe = {
  id: 2,
  name: 'ది గోల్డెన్ క్యూబ్',
  volume: '100ml షాట్',
  focus: 'కీళ్ళ ఆరోగ్యం, రికవరీ & రోగనిరోధకత',
  emoji: '🟡',
  accent: '#d4a017',
  accentLight: '#fffbf0',
  accentBorder: '#fde9a0',
  image: '/The_Golden_Cube_1.png',
  points: [
    { title: 'కర్క్యుమిన్ సక్రియత', desc: 'మా సహజ తయారీ ప్రక్రియ ద్వారా పసుపులోని కర్క్యుమిన్ 5 రెట్లు అధికంగా శోషించబడుతుంది.' },
    { title: 'సహజ వాపు నివారణ', desc: 'కీళ్ళ నొప్పి మరియు వాపుకు కారణమయ్యే ఎంజైమ్‌లను భౌతికంగా నిరోధిస్తుంది.' },
    { title: 'కండర రికవరీ', desc: 'భారీ శారీరక శ్రమ లేదా జిమ్ తర్వాత కణజాలాల మరమ్మత్తును వేగవంతం చేస్తుంది.' },
    { title: 'రోగనిరోధక వ్యవస్థ బలోపేతం', desc: 'తెల్ల రక్త కణాలను సక్రియం చేసి కాలానుగుణ అంటువ్యాధులకు వ్యతిరేకంగా రక్షణ కల్పిస్తుంది.' },
    { title: 'పైపెరిన్ సమన్వయం', desc: 'నల్ల మిరియాలతో కలిపి పసుపు శోషణను 2,000% పెంచుతుంది.' },
    { title: 'పేగు పొర మరమ్మత్తు', desc: 'జీర్ణ వ్యవస్థను శాంతపరచి లీకీ గట్ సమస్యలను నయం చేయడంలో సహాయపడుతుంది.' },
    { title: 'మెదడు ఆరోగ్యం', desc: 'జ్ఞాపకశక్తి మరియు ఏకాగ్రతను మెరుగుపరిచే మెదడు ప్రోటీన్ల ఉత్పత్తికి మద్దతు ఇస్తుంది.' },
    { title: 'లింఫాటిక్ డ్రైనేజ్', desc: 'నీటి నిల్వను తగ్గించడానికి లింఫ్ ద్రవాల కదలికను ప్రేరేపిస్తుంది.' },
    { title: 'యాంటీబాక్టీరియల్ రక్షణ', desc: 'పేగు వాతావరణాన్ని ఆరోగ్యంగా ఉంచడానికి సహజ అంతర్గత శుభ్రపరిచే పదార్థంగా పనిచేస్తుంది.' },
    { title: 'ట్రేస్ మినరల్స్ సమృద్ధి', desc: 'మా కళాత్మక తయారీ ప్రక్రియ ప్రతి బంగారు చుక్కలో అవసరమైన ట్రేస్ మినరల్స్‌ను నిలుపుతుంది.' },
  ],
};

const fireballTe = {
  id: 3,
  name: 'ది ఫైర్‌బాల్ షాట్',
  volume: '100ml షాట్',
  focus: 'జీవక్రియ, వేడి & శ్వాసకోశ సమస్యలు',
  emoji: '🔥',
  accent: '#e05c00',
  accentLight: '#fff5f0',
  accentBorder: '#ffd0b0',
  image: '/The_Fireball_Shot_1.png',
  points: [
    { title: 'జీవక్రియ జ్వలన', desc: 'థర్మోజెనిసిస్‌ను ప్రేరేపించి శరీరం కేలరీలను మరింత సమర్థవంతంగా దహించేలా చేస్తుంది.' },
    { title: 'తక్షణ సైనస్ ఉపశమనం', desc: 'అల్లం మరియు కేయెన్ వేడి నాసికా మరియు ఊపిరితిత్తుల అడ్డంకులను తక్షణమే తొలగిస్తాయి.' },
    { title: 'ఆకలి నియంత్రణ', desc: 'చక్కెర కోరికలు మరియు మధ్యాహ్న ఆకలిని సహజంగా అణిచివేస్తుంది.' },
    { title: 'అడ్రినల్ మద్దతు', desc: 'కెఫీన్ వణుకు లేకుండా తీక్షణమైన మానసిక మేల్కొలుపు అందిస్తుంది.' },
    { title: 'కొవ్వు ఆక్సీకరణ', desc: 'శరీరం నిల్వ చేసిన కొవ్వును చురుకైన శక్తి వనరుగా ఉపయోగించేలా ప్రోత్సహిస్తుంది.' },
    { title: 'శ్వాసకోశ బలం', desc: 'శ్లేష్మాన్ని సన్నగా చేయడం ద్వారా ఆస్తమా లేదా దీర్ఘకాలిక దగ్గు నిర్వహణలో సహాయపడుతుంది.' },
    { title: 'ఆరోగ్యకరమైన రక్త ప్రసరణ', desc: 'చేతులు మరియు పాదాలకు రక్త ప్రవాహాన్ని వేగంగా ప్రేరేపిస్తుంది.' },
    { title: 'జీర్ణ అగ్ని (అగ్ని)', desc: 'భారీ భోజనాన్ని మరింత సమర్థవంతంగా జీర్ణించుకోవడానికి గ్యాస్ట్రిక్ ఎంజైమ్‌లను రగిలిస్తుంది.' },
    { title: 'ఎండార్ఫిన్ పెరుగుదల', desc: 'సహజ మసాలా మూడ్ లిఫ్ట్ కోసం మంచి అనుభూతి కలిగించే మెదడు రసాయనాలను ప్రేరేపిస్తుంది.' },
    { title: 'యాంటీఆక్సిడెంట్ పెరుగుదల', desc: 'కేంద్రీకృత నిమ్మకాయ మరియు అల్లం విటమిన్ C యొక్క భారీ మోతాదు అందిస్తాయి.' },
  ],
};

const glucoseTe = {
  id: 4,
  name: 'ది గ్లూకోజ్ గార్డ్',
  volume: '100ml షాట్',
  focus: 'రక్తంలో చక్కెర, క్లోమం & చేదు పోషణ',
  emoji: '💚',
  accent: '#1a7a3c',
  accentLight: '#f0faf4',
  accentBorder: '#b2dfcc',
  image: '/The_Glucose_Guard_1.png',
  points: [
    { title: 'ఇన్సులిన్ అనుకరణ', desc: 'ఇన్సులిన్ మొక్కలోని సమ్మేళనాలు కణాలు రక్తం నుండి చక్కెరను సహజంగా గ్రహించేలా సహాయపడతాయి.' },
    { title: 'చక్కెర శోషణ నిరోధకం', desc: 'కారెళ్ళ పేగులోని చక్కెర గ్రాహకాలు గ్లూకోజ్‌ను అధికంగా శోషించకుండా నిరోధిస్తాయి.' },
    { title: 'క్లోమ మద్దతు', desc: 'రక్తంలో చక్కెర స్థాయిలను స్థిరీకరించడం ద్వారా క్లోమంపై పని భారాన్ని తగ్గించడంలో సహాయపడుతుంది.' },
    { title: 'మునగ సూపర్-పోషణ', desc: 'ఒక షాట్‌లో పాలకంటే ఎక్కువ కాల్షియం మరియు నారింజకంటే ఎక్కువ విటమిన్ C అందిస్తుంది.' },
    { title: 'క్లోరోఫిల్ డిటాక్స్', desc: 'పచ్చని రక్త అణువులు మానవ వ్యవస్థ నుండి భారీ లోహాలను బయటకు పంపడంలో సహాయపడతాయి.' },
    { title: 'మైక్రోగ్రీన్ శక్తి', desc: 'కణ మరమ్మత్తు కోసం పరిపక్వ కూరగాయల కంటే 40 రెట్లు ఎక్కువ పోషకాలు కలిగి ఉంటుంది.' },
    { title: 'యాంటీ-డయాబెటిక్ టానిక్', desc: 'టైప్-2 డయాబెటిస్ నిర్వహణకు మద్దతు ఇవ్వడానికి సాంప్రదాయకంగా రూపొందించబడింది.' },
    { title: 'పేగు మైక్రోబయోమ్ సమతుల్యత', desc: 'సహజ అల్లం బేస్ చేదు ఔషధ ఆకులు సులభంగా జీర్ణమయ్యేలా నిర్ధారిస్తుంది.' },
    { title: 'హార్మోన్ సమతుల్యత', desc: 'ఒత్తిడి వల్ల కలిగే చక్కెర పెరుగుదలను నిర్వహించడానికి ఎండోక్రైన్ వ్యవస్థకు మద్దతు ఇస్తుంది.' },
    { title: 'జీవక్రియ రక్షణ', desc: 'కార్బోహైడ్రేట్లను నిర్వహించే శరీరం యొక్క సహజ సామర్థ్యాన్ని బలపరుస్తుంది.' },
  ],
};

const ashGuardTe = {
  id: 5,
  name: 'యాష్ గార్డ్ జ్యూస్',
  volume: '180ml / 250ml జ్యూస్',
  focus: 'pH సమతుల్యత, శీతలీకరణ & జలయోజనం',
  emoji: '🩵',
  accent: '#0077a8',
  accentLight: '#f0f8fc',
  accentBorder: '#b0ddf0',
  image: '/Ash_Guard_1.png',
  points: [
    { title: 'ఆల్కలైన్ అగ్ని నిర్వాపకం', desc: 'భూమిపై అత్యంత ఆల్కలైన్ ఆహారాలలో ఒకటి; కడుపు ఆమ్లతను తక్షణమే తటస్థపరుస్తుంది.' },
    { title: 'కణ జలయోజనం', desc: 'సాదా నీటి కంటే శరీరంలో నీటిని ఎక్కువ సేపు నిలుపుకుంటుంది, హైదరాబాద్ వేడిలో మిమ్మల్ని హైడ్రేటెడ్‌గా ఉంచుతుంది.' },
    { title: 'అంతర్గత శీతలీకరణ', desc: 'పుండ్లు, దద్దుర్లు మరియు చిరాకుకు కారణమయ్యే పిత్త లేదా శరీర వేడిని తగ్గిస్తుంది.' },
    { title: 'మానసిక స్పష్టత', desc: 'ఏకాగ్రతను మెరుగుపరచి ఆందోళనను తగ్గించే ఆయుర్వేద మెదడు టానిక్.' },
    { title: 'మూత్రపిండాల మద్దతు', desc: 'రాళ్ళను కరిగించి మూత్ర సంక్రమణలను నివారించడానికి సహజ మూత్రవర్ధకంగా పనిచేస్తుంది.' },
    { title: 'బరువు నిర్వహణ', desc: 'కేలరీలలో చాలా తక్కువగా ఉంటుంది కానీ సంతృప్తిలో చాలా ఎక్కువగా ఉంటుంది, మిమ్మల్ని ఎక్కువ సేపు నిండుగా అనిపిస్తుంది.' },
    { title: 'కడుపు పొర రక్షణ', desc: 'పుండ్లను నయం చేయడంలో సహాయపడటానికి జీర్ణ వ్యవస్థను కప్పి శాంతపరుస్తుంది.' },
    { title: 'శ్లేష్మ తొలగింపు', desc: 'ఊపిరితిత్తులు మరియు శ్వాసకోశ వ్యవస్థ నుండి అధిక శ్లేష్మాన్ని తొలగించడంలో సహాయపడుతుంది.' },
    { title: 'జింక్ & మినరల్స్ సమృద్ధి', desc: 'చర్మ మరమ్మత్తు, జుట్టు ఆరోగ్యం మరియు రోగనిరోధక రక్షణకు అవసరం.' },
    { title: 'స్వచ్ఛమైన కూరగాయల ప్లాస్మా', desc: 'అదనపు నీరు, చక్కెర లేదా రసాయనాలు లేకుండా 100% సహజ వెలికితీత.' },
  ],
};

const berryTe = {
  id: 6,
  name: 'బెర్రీ బనానా బూస్ట్',
  volume: '180ml స్మూతీ',
  focus: 'శక్తి, సంతృప్తి & మెదడు ఆరోగ్యం',
  emoji: '🫐',
  accent: '#6a1b9a',
  accentLight: '#faf0ff',
  accentBorder: '#ddb8f5',
  image: '/Berry_Banana_Boost_1.png',
  points: [
    { title: 'సింబయోటిక్ శక్తి', desc: 'సూపర్-గట్ పరిష్కారం కోసం ప్రీబయోటిక్స్ (అరటి ఫైబర్) మరియు ప్రోబయోటిక్స్‌ను కలుపుతుంది.' },
    { title: 'నిరంతర శక్తి', desc: 'క్రాష్ లేకుండా శక్తిని స్థిరంగా విడుదల చేయడానికి సంక్లిష్ట కార్బోహైడ్రేట్లు అందిస్తుంది.' },
    { title: 'యాంటీఆక్సిడెంట్ రక్షణ', desc: 'అడవి బెర్రీలు మెదడు కణాలను ఆక్సీకరణ ఒత్తిడి నుండి రక్షించడానికి యాంథోసయానిన్‌లు అందిస్తాయి.' },
    { title: 'పొటాషియం సమృద్ధి', desc: 'ఆరోగ్యకరమైన గుండె పనితీరుకు మద్దతు ఇస్తుంది మరియు కండర తిమ్మిర్లను నివారిస్తుంది.' },
    { title: 'భోజన ప్రత్యామ్నాయం', desc: 'సహజంగా 2-3 గంటలు ఆకలిని తీర్చే మందమైన, క్రీమీ ఆకృతి.' },
    { title: 'జీర్ణానికి అనుకూలం', desc: 'ఉబ్బరాన్ని నివారించడానికి 100% వేగన్ మరియు సహజంగా తయారు చేయబడింది.' },
    { title: 'విటమిన్ C పవర్‌హౌస్', desc: 'బెర్రీలు ఆరోగ్యకరమైన చర్మం కోసం కొల్లాజెన్ ఉత్పత్తికి భారీ పెరుగుదల అందిస్తాయి.' },
    { title: 'మానసిక ఏకాగ్రత', desc: 'సహజ చక్కెరలు మరియు ఎలక్ట్రోలైట్ల కలయిక విద్యార్థులు మరియు నిపుణుల కోసం మెదడును తీక్షణంగా ఉంచుతుంది.' },
    { title: 'జీరో రిఫైన్డ్ షుగర్', desc: 'పూర్తిగా సేంద్రీయ, పండిన పండ్ల ద్వారా తీపి చేయబడింది — ఎటువంటి అదనపు చక్కెర లేదు.' },
    { title: 'వ్యాయామం తర్వాత రికవరీ', desc: 'కండరాలను నయం చేయడానికి మినరల్స్ మరియు యాంటీ-ఇన్ఫ్లమేటరీ బెర్రీల సరైన సమతుల్యత.' },
  ],
};

const productsTe = [rubyTe, goldenTe, fireballTe, glucoseTe, ashGuardTe, berryTe];

const plantsEn = [
  {
    id: 1,
    name: 'Bone Setter',
    localName: 'Nalleru / Pirandai',
    emoji: '🦴',
    image: '/Bone_Setter_Plant_1.png',
    benefits: ['Accelerates bone fracture healing', 'Reduces joint pain and inflammation', 'Strengthens ligaments and tendons', 'Rich in Vitamin C and calcium'],
    uses: ['Juice extracted from stem consumed for bone health', 'Paste applied externally on fractures', 'Dried powder mixed with sesame oil for massage', 'Used in traditional Ayurvedic bone-setting medicine'],
    bioInfo: { scientificName: 'Cissus quadrangularis', family: 'Vitaceae', origin: 'India, Sri Lanka, Africa', type: 'Succulent climbing shrub' },
  },
  {
    id: 2,
    name: 'Holy Basil',
    localName: 'Tulsi',
    emoji: '🌿',
    image: '/holy_basil_1.png',
    benefits: ['Powerful adaptogen — reduces stress and anxiety', 'Boosts immunity and fights infections', 'Anti-inflammatory and antioxidant properties', 'Supports respiratory health'],
    uses: ['Fresh leaves chewed daily for immunity', 'Tulsi tea for cold, cough and fever', 'Leaves boiled in water for steam inhalation', 'Used in Ayurvedic formulations for centuries'],
    bioInfo: { scientificName: 'Ocimum tenuiflorum', family: 'Lamiaceae', origin: 'Indian subcontinent', type: 'Aromatic perennial herb' },
  },
  {
    id: 3,
    name: 'Aloe Vera',
    localName: 'Kalabanda / Ghritkumari',
    emoji: '🌵',
    image: '/aloe_vera_1.png',
    benefits: ['Soothes burns, wounds and skin irritation', 'Aids digestion and relieves constipation', 'Hydrates and nourishes skin deeply', 'Lowers blood sugar levels naturally'],
    uses: ['Gel applied directly on skin for burns and acne', 'Juice consumed for gut health and detox', 'Mixed in hair masks for scalp nourishment', 'Used in cosmetics, creams and sunscreens'],
    bioInfo: { scientificName: 'Aloe barbadensis miller', family: 'Asphodelaceae', origin: 'Arabian Peninsula', type: 'Succulent perennial plant' },
  },
  {
    id: 4,
    name: 'Turmeric',
    localName: 'Pasupu / Haldi',
    emoji: '🟡',
    image: '/turmeric_1.png',
    benefits: ['Curcumin — potent anti-inflammatory compound', 'Powerful antioxidant that neutralises free radicals', 'Improves brain function and lowers risk of disease', 'Natural antiseptic and antibacterial agent'],
    uses: ['Golden milk (turmeric + warm milk) for immunity', 'Applied on wounds as natural antiseptic paste', 'Used in cooking for flavour and health benefits', 'Face packs for glowing, clear skin'],
    bioInfo: { scientificName: 'Curcuma longa', family: 'Zingiberaceae', origin: 'South Asia (India)', type: 'Rhizomatous herbaceous perennial' },
  },
  // {
  //   id: 5,
  //   name: 'Neem',
  //   localName: 'Vepa / Nimba',
  //   emoji: '🍃',
  //   image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Neem_leaves_and_flowers.jpg/800px-Neem_leaves_and_flowers.jpg',
  //   benefits: ['Powerful antibacterial and antifungal properties', 'Purifies blood and detoxifies the body', 'Controls blood sugar in diabetic patients', 'Natural pesticide — protects crops organically'],
  //   uses: ['Neem twigs used as natural toothbrush', 'Leaf paste applied for skin infections and acne', 'Neem oil used in hair care to prevent dandruff', 'Boiled leaf water used for bathing skin conditions'],
  //   bioInfo: { scientificName: 'Azadirachta indica', family: 'Meliaceae', origin: 'Indian subcontinent', type: 'Fast-growing tropical tree' },
  // },
  {
    id: 6,
    name: 'Ranaphala (Miracle Leaf)',
    localName: 'Pashanabheda / Bryophyllum',
    emoji: '🪨',
    image: '/ranapala_1.png',
    benefits: [
      'Kidney & gallbladder stones — contains compounds that dissolve calcium oxalate crystals',
      'Powerful natural diuretic — flushes the urinary tract and prevents recurrent UTIs',
      'Anti-ulcer — coats the stomach lining to heal chronic acidity and peptic ulcers',
      'Wound healing — high antibacterial compounds help repair internal tissue damage',
      'Blood pressure control — cardiac glycosides help regulate heart rate and relax blood vessels',
    ],
    uses: [
      'Leaf juice consumed for kidney stone support',
      'Fresh leaf paste applied externally on wounds and skin infections',
      'Leaf decoction taken for urinary tract health',
      'Used in Ayurvedic formulations as Pashanabheda (The Stone Breaker)',
    ],
    bioInfo: { scientificName: 'Bryophyllum pinnatum', family: 'Crassulaceae', origin: 'Madagascar, widely naturalised in India & Africa', type: 'Succulent perennial herb' },
  },
  {
    id: 7,
    name: 'Insulin Plant',
    localName: 'Kostum / Insulin Leaf',
    emoji: '🩺',
    image: '/insulin_1.png',
    benefits: [
      'Natural blood sugar regulator — contains corosolic acid that helps process glucose efficiently, mimicking insulin action',
      'Improves insulin sensitivity — unlocks muscle cells to absorb sugar from the bloodstream',
      'Pancreatic support — protects Beta-cells in the pancreas that produce natural insulin',
      'Anti-glycation agent — prevents sugar from sticking to blood proteins, reducing premature aging and organ damage',
      'Kidney protection — antioxidants provide a protective shield for the renal system against high sugar damage',
      'Cholesterol management — lowers LDL (bad cholesterol) and triglycerides',
      'Powerful antioxidant — rich in Vitamin E, C, and Beta-carotene to fight oxidative stress',
      'Anti-bacterial properties — keeps the gut free of harmful bacteria, supporting a clean microbiome',
    ],
    uses: [
      'Fresh leaves consumed daily for blood sugar management',
      'Leaf juice taken for metabolic support',
      'Used in traditional medicine for Type-2 diabetes support',
      'Natural diuretic to flush out toxins and support digestive health',
    ],
    bioInfo: { scientificName: 'Chamaecostus cuspidatus', family: 'Costaceae', origin: 'Central & South America, naturalised in India', type: 'Perennial herbaceous plant' },
  },
  {
    id: 8,
    name: 'African Bitter Leaf',
    localName: 'Vernonia / King of Bitters',
    emoji: '🌿',
    image: '/bitterleaf_1.png',
    benefits: [
      'Insulin sensitivity — sesquiterpene lactones help the body use its own insulin more effectively',
      'Liver regeneration — stimulates fresh bile production and protects liver cells from damage',
      'Anti-parasitic — acts as a natural dewormer, clearing harmful parasites and balancing the gut microbiome',
      'Cholesterol management — lowers LDL (bad cholesterol) while supporting HDL (good cholesterol)',
      'Fever & immune support — helps the immune system fight off viral and bacterial loads',
    ],
    uses: [
      'Leaf juice consumed for blood sugar and metabolic support',
      'Fresh leaves used in traditional soups and tonics for liver health',
      'Leaf extract taken as a natural anti-parasitic remedy',
      'Used across West Africa and Ayurvedic traditions for metabolic and immune health',
    ],
    bioInfo: { scientificName: 'Vernonia amygdalina', family: 'Asteraceae', origin: 'Tropical Africa', type: 'Perennial shrub' },
  },
];

const plantsTe = [
  {
    id: 1,
    name: 'నల్లేరు',
    localName: 'నల్లేరు / పిరండై',
    emoji: '🦴',
    image: '/Bone_Setter_Plant_1.png',
    benefits: ['ఎముక విరుపుల నయాన్ని వేగవంతం చేస్తుంది', 'కీళ్ళ నొప్పి మరియు వాపును తగ్గిస్తుంది', 'స్నాయువులు మరియు కండరాలను బలపరుస్తుంది', 'విటమిన్ C మరియు కాల్షియం సమృద్ధిగా ఉంటుంది'],
    uses: ['ఎముక ఆరోగ్యం కోసం కాండం నుండి రసం తీసి సేవిస్తారు', 'విరుపులపై బయటగా పేస్ట్ పూస్తారు', 'ఎండిన పొడిని నువ్వుల నూనెతో కలిపి మసాజ్ చేస్తారు', 'సాంప్రదాయ ఆయుర్వేద ఎముక-కలుపు వైద్యంలో ఉపయోగిస్తారు'],
    bioInfo: { scientificName: 'Cissus quadrangularis', family: 'Vitaceae', origin: 'భారతదేశం, శ్రీలంక, ఆఫ్రికా', type: 'రసభరిత పాకే పొద' },
  },
  {
    id: 2,
    name: 'తులసి',
    localName: 'తులసి',
    emoji: '🌿',
    image: '/holy_basil_1.png',
    benefits: ['శక్తివంతమైన అడాప్టోజెన్ — ఒత్తిడి మరియు ఆందోళనను తగ్గిస్తుంది', 'రోగనిరోధక శక్తిని పెంచి అంటువ్యాధులతో పోరాడుతుంది', 'వాపు నివారణ మరియు యాంటీఆక్సిడెంట్ గుణాలు', 'శ్వాసకోశ ఆరోగ్యానికి మద్దతు ఇస్తుంది'],
    uses: ['రోగనిరోధక శక్తి కోసం రోజూ తాజా ఆకులు నమలాలి', 'జలుబు, దగ్గు మరియు జ్వరానికి తులసి టీ', 'ఆవిరి పీల్చడానికి ఆకులను నీటిలో మరిగించాలి', 'శతాబ్దాలుగా ఆయుర్వేద ఔషధాలలో ఉపయోగిస్తున్నారు'],
    bioInfo: { scientificName: 'Ocimum tenuiflorum', family: 'Lamiaceae', origin: 'భారత ఉపఖండం', type: 'సుగంధభరిత బహువార్షిక మూలిక' },
  },
  {
    id: 3,
    name: 'కలబంద',
    localName: 'కలబంద / ఘృతకుమారి',
    emoji: '🌵',
    image: '/aloe_vera_1.png',
    benefits: ['కాలిన గాయాలు, పుండ్లు మరియు చర్మ చికాకును శాంతపరుస్తుంది', 'జీర్ణక్రియకు సహాయపడి మలబద్ధకాన్ని తగ్గిస్తుంది', 'చర్మాన్ని లోతుగా తేమగా మరియు పోషించుతుంది', 'రక్తంలో చక్కెర స్థాయిలను సహజంగా తగ్గిస్తుంది'],
    uses: ['కాలిన గాయాలు మరియు మొటిమలకు చర్మంపై నేరుగా జెల్ పూస్తారు', 'పేగు ఆరోగ్యం మరియు డిటాక్స్ కోసం రసం సేవిస్తారు', 'తల చర్మ పోషణ కోసం హెయిర్ మాస్క్‌లలో కలుపుతారు', 'సౌందర్య సాధనాలు, క్రీమ్‌లు మరియు సన్‌స్క్రీన్‌లలో ఉపయోగిస్తారు'],
    bioInfo: { scientificName: 'Aloe barbadensis miller', family: 'Asphodelaceae', origin: 'అరేబియా ద్వీపకల్పం', type: 'రసభరిత బహువార్షిక మొక్క' },
  },
  {
    id: 4,
    name: 'పసుపు',
    localName: 'పసుపు / హల్దీ',
    emoji: '🟡',
    image: '/turmeric_1.png',
    benefits: ['కర్క్యుమిన్ — శక్తివంతమైన వాపు నివారణ సమ్మేళనం', 'స్వేచ్ఛా రాడికల్స్‌ను తటస్థపరిచే శక్తివంతమైన యాంటీఆక్సిడెంట్', 'మెదడు పనితీరును మెరుగుపరచి వ్యాధి ప్రమాదాన్ని తగ్గిస్తుంది', 'సహజ యాంటీసెప్టిక్ మరియు యాంటీబాక్టీరియల్ కారకం'],
    uses: ['రోగనిరోధక శక్తి కోసం గోల్డెన్ మిల్క్ (పసుపు + వెచ్చని పాలు)', 'పుండ్లపై సహజ యాంటీసెప్టిక్ పేస్ట్‌గా పూస్తారు', 'వంట్లో రుచి మరియు ఆరోగ్య ప్రయోజనాల కోసం ఉపయోగిస్తారు', 'మెరిసే, స్వచ్ఛమైన చర్మం కోసం ఫేస్ ప్యాక్‌లు'],
    bioInfo: { scientificName: 'Curcuma longa', family: 'Zingiberaceae', origin: 'దక్షిణ ఆసియా (భారతదేశం)', type: 'కందమూల బహువార్షిక మొక్క' },
  },
  // {
  //   id: 5,
  //   name: 'వేప',
  //   localName: 'వేప / నింబ',
  //   emoji: '🍃',
  //   image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Neem_leaves_and_flowers.jpg/800px-Neem_leaves_and_flowers.jpg',
  //   benefits: ['శక్తివంతమైన యాంటీబాక్టీరియల్ మరియు యాంటీఫంగల్ గుణాలు', 'రక్తాన్ని శుద్ధి చేసి శరీరాన్ని విషముక్తం చేస్తుంది', 'మధుమేహ రోగులలో రక్తంలో చక్కెరను నియంత్రిస్తుంది', 'సహజ పురుగుమందు — పంటలను సేంద్రీయంగా రక్షిస్తుంది'],
  //   uses: ['వేప కొమ్మలు సహజ టూత్‌బ్రష్‌గా ఉపయోగిస్తారు', 'చర్మ సంక్రమణలు మరియు మొటిమలకు ఆకు పేస్ట్ పూస్తారు', 'చుండ్రు నివారించడానికి జుట్టు సంరక్షణలో వేప నూనె ఉపయోగిస్తారు', 'చర్మ పరిస్థితులకు స్నానానికి మరిగించిన ఆకు నీరు ఉపయోగిస్తారు'],
  //   bioInfo: { scientificName: 'Azadirachta indica', family: 'Meliaceae', origin: 'భారత ఉపఖండం', type: 'వేగంగా పెరిగే ఉష్ణమండల చెట్టు' },
  // },
  {
    id: 6,
    name: 'రణఫల (మిరాకిల్ లీఫ్)',
    localName: 'పాషాణభేద / బ్రయోఫిల్లమ్',
    emoji: '🪨',
    image: '/ranapala_1.png',
    benefits: [
      'మూత్రపిండ & పిత్తాశయ రాళ్ళు — కాల్షియం ఆక్సలేట్ స్ఫటికాలను విచ్ఛిన్నం చేసే సమ్మేళనాలు కలిగి ఉంటుంది',
      'శక్తివంతమైన సహజ మూత్రవర్ధకం — మూత్ర మార్గాన్ని శుభ్రపరచి పునరావృత UTIలను నివారిస్తుంది',
      'అల్సర్ నివారణ — దీర్ఘకాలిక ఆమ్లత మరియు పెప్టిక్ అల్సర్లను నయం చేయడానికి కడుపు పొరను కప్పుతుంది',
      'గాయం నయం — అధిక యాంటీబాక్టీరియల్ సమ్మేళనాలు అంతర్గత కణజాల నష్టాన్ని మరమ్మత్తు చేయడంలో సహాయపడతాయి',
      'రక్తపోటు నియంత్రణ — కార్డియాక్ గ్లైకోసైడ్లు గుండె స్పందన రేటును నియంత్రించి రక్తనాళాలను సడలిస్తాయి',
    ],
    uses: [
      'మూత్రపిండ రాళ్ళ మద్దతు కోసం ఆకు రసం సేవిస్తారు',
      'గాయాలు మరియు చర్మ సంక్రమణలపై తాజా ఆకు పేస్ట్ బయటగా పూస్తారు',
      'మూత్ర మార్గ ఆరోగ్యం కోసం ఆకు కషాయం తీసుకుంటారు',
      'పాషాణభేద (రాయి విచ్ఛిన్నకారి) గా ఆయుర్వేద ఔషధాలలో ఉపయోగిస్తారు',
    ],
    bioInfo: { scientificName: 'Bryophyllum pinnatum', family: 'Crassulaceae', origin: 'మడగాస్కర్, భారతదేశం & ఆఫ్రికాలో విస్తృతంగా వ్యాపించింది', type: 'రసభరిత బహువార్షిక మూలిక' },
  },
  {
    id: 7,
    name: 'ఇన్సులిన్ మొక్క',
    localName: 'కోస్తుమ్ / ఇన్సులిన్ ఆకు',
    emoji: '🩺',
    image: '/insulin_1.png',
    benefits: [
      'సహజ రక్త చక్కెర నియంత్రణ — కోరోసోలిక్ యాసిడ్ కలిగి ఉంటుంది, ఇది గ్లూకోజ్ను సమర్థవంతంగా ప్రాసెస్ చేయడంలో సహాయపడుతుంది, ఇన్సులిన్ చర్యను అనుకరిస్తుంది',
      'ఇన్సులిన్ సంవేదనశీలత మెరుగుపరుస్తుంది — కండర కణాలను అన్‌లాక్ చేసి రక్తప్రవాహం నుండి చక్కెరను గ్రహించేలా చేస్తుంది',
      'క్లోమ మద్దతు — సహజ ఇన్సులిన్ ఉత్పత్తి చేసే క్లోమంలోని బీటా-కణాలను రక్షిస్తుంది',
      'యాంటీ-గ్లైకేషన్ ఏజెంట్ — చక్కెర రక్త ప్రోటీన్లకు అంటుకోకుండా నివారిస్తుంది, అకాల వృద్ధాప్యం మరియు అవయవ నష్టాన్ని తగ్గిస్తుంది',
      'మూత్రపిండాల రక్షణ — యాంటీఆక్సిడెంట్లు అధిక చక్కెర నష్టం నుండి మూత్రపిండ వ్యవస్థకు రక్షణ కవచం అందిస్తాయి',
      'కొలెస్ట్రాల్ నిర్వహణ — LDL (చెడు కొలెస్ట్రాల్) మరియు ట్రైగ్లిజరైడ్లను తగ్గిస్తుంది',
      'శక్తివంతమైన యాంటీఆక్సిడెంట్ — విటమిన్ E, C మరియు బీటా-కెరోటిన్ సమృద్ధిగా ఉంటుంది, ఆక్సీకరణ ఒత్తిడితో పోరాడుతుంది',
      'యాంటీ-బాక్టీరియల్ గుణాలు — పేగును హానికరమైన బ్యాక్టీరియా నుండి విముక్తం చేస్తుంది, శుభ్రమైన మైక్రోబయోమ్‌కు మద్దతు ఇస్తుంది',
    ],
    uses: [
      'రక్త చక్కెర నిర్వహణ కోసం రోజూ తాజా ఆకులు సేవిస్తారు',
      'జీవక్రియ మద్దతు కోసం ఆకు రసం తీసుకుంటారు',
      'టైప్-2 డయాబెటిస్ మద్దతు కోసం సాంప్రదాయ వైద్యంలో ఉపయోగిస్తారు',
      'విషపదార్థాలను బయటకు పంపడానికి మరియు జీర్ణ ఆరోగ్యానికి సహజ మూత్రవర్ధకం',
    ],
    bioInfo: { scientificName: 'Chamaecostus cuspidatus', family: 'Costaceae', origin: 'మధ్య & దక్షిణ అమెరికా, భారతదేశంలో సహజీకరించబడింది', type: 'బహువార్షిక మూలికా మొక్క' },
  },
  {
    id: 8,
    name: 'ఆఫ్రికన్ బిట్టర్ లీఫ్',
    localName: 'వెర్నోనియా / కింగ్ ఆఫ్ బిట్టర్స్',
    emoji: '🌿',
    image: '/bitterleaf_1.png',
    benefits: [
      'ఇన్సులిన్ సంవేదనశీలత — సెస్క్విటెర్పీన్ లాక్టోన్లు శరీరం తన స్వంత ఇన్సులిన్ను మరింత సమర్థవంతంగా ఉపయోగించేలా సహాయపడతాయి',
      'కాలేయ పునరుత్పత్తి — తాజా పిత్త ఉత్పత్తిని ప్రేరేపించి కాలేయ కణాలను నష్టం నుండి రక్షిస్తుంది',
      'పరాన్నజీవి నివారణ — సహజ పురుగు నివారణిగా పనిచేసి హానికరమైన పరాన్నజీవులను తొలగించి పేగు మైక్రోబయోమ్ను సమతుల్యం చేస్తుంది',
      'కొలెస్ట్రాల్ నిర్వహణ — HDL (మంచి కొలెస్ట్రాల్)కు మద్దతు ఇస్తూ LDL (చెడు కొలెస్ట్రాల్)ను తగ్గిస్తుంది',
      'జ్వరం & రోగనిరోధక మద్దతు — వైరల్ మరియు బాక్టీరియల్ లోడ్లను ఎదుర్కోవడంలో రోగనిరోధక వ్యవస్థకు సహాయపడుతుంది',
    ],
    uses: [
      'రక్తంలో చక్కెర మరియు జీవక్రియ మద్దతు కోసం ఆకు రసం సేవిస్తారు',
      'కాలేయ ఆరోగ్యం కోసం సాంప్రదాయ సూప్లు మరియు టానిక్లలో తాజా ఆకులు ఉపయోగిస్తారు',
      'సహజ పరాన్నజీవి నివారణ ఔషధంగా ఆకు సారం తీసుకుంటారు',
      'జీవక్రియ మరియు రోగనిరోధక ఆరోగ్యం కోసం పశ్చిమ ఆఫ్రికా మరియు ఆయుర్వేద సంప్రదాయాలలో ఉపయోగిస్తారు',
    ],
    bioInfo: { scientificName: 'Vernonia amygdalina', family: 'Asteraceae', origin: 'ఉష్ణమండల ఆఫ్రికా', type: 'బహువార్షిక పొద' },
  },
];

/* ── Accordion card (mobile only) ── */
function AccordionCard({ item, isProduct }) {
  const [open, setOpen] = useState(false);
  const bodyRef = useRef(null);
  const accent = item.accent || '#133c0b';
  const accentLight = item.accentLight || '#e8f5e9';
  const accentBorder = item.accentBorder || '#c8e6c9';

  return (
    <div className={`acc-card ${open ? 'acc-card--open' : ''}`}>
      <button
        className="acc-header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        style={{ borderLeft: `4px solid ${accent}` }}
      >
        <div className="acc-thumb">
          <img src={item.image} alt={item.name} />
        </div>
        <div className="acc-header-info">
          <div className="acc-name-row">
            <span className="acc-emoji">{item.emoji}</span>
            <div>
              <h3 style={{ color: accent }}>{item.name}</h3>
              <span className="acc-sub">{isProduct ? item.volume : item.localName}</span>
            </div>
          </div>
          {isProduct && (
            <span
              className="acc-focus-tag"
              style={{ background: accentLight, color: accent, border: `1px solid ${accentBorder}` }}
            >
              🎯 {item.focus}
            </span>
          )}
        </div>
        <div className={`acc-chevron ${open ? 'acc-chevron--up' : ''}`} style={{ color: accent }}>
          ▾
        </div>
      </button>

      <div
        className="acc-body"
        ref={bodyRef}
        style={{ maxHeight: open ? (bodyRef.current ? bodyRef.current.scrollHeight + 'px' : '2000px') : '0px' }}
      >
        <div className="acc-body-inner">
          {isProduct ? (
            <div className="br-points-list">
              {item.points.map((pt, i) => (
                <div className="br-point-mobile" key={i}>
                  <div className="br-point-dot" style={{ background: accent }} />
                  <div>
                    <strong style={{ color: accent }}>{pt.title}</strong>
                    <p>{pt.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="pg-section">
                <h3>✅ {item.lang === 'te' ? 'ఫాయిదాలు' : 'Benefits'}</h3>
                <ul>{item.benefits.map((b, i) => <li key={i}>{b}</li>)}</ul>
              </div>
              <div className="pg-section">
                <h3>💊 {item.lang === 'te' ? 'ఎలా ఉపయోగించాలి' : 'How to Use'}</h3>
                <ul>{item.uses.map((u, i) => <li key={i}>{u}</li>)}</ul>
              </div>
              <div className="pg-section pg-bio">
                <h3>🔬 {item.lang === 'te' ? 'జీవశాస్త్ర సమాచారం' : 'Biological Information'}</h3>
                <div className="pg-bio-grid">
                  <div><span>{item.lang === 'te' ? 'శాస్త్రీయ పేరు' : 'Scientific Name'}</span><strong><em>{item.bioInfo.scientificName}</em></strong></div>
                  <div><span>{item.lang === 'te' ? 'కుటుంబం' : 'Family'}</span><strong>{item.bioInfo.family}</strong></div>
                  <div><span>{item.lang === 'te' ? 'మూలం' : 'Origin'}</span><strong>{item.bioInfo.origin}</strong></div>
                  <div><span>{item.lang === 'te' ? 'రకం' : 'Type'}</span><strong>{item.bioInfo.type}</strong></div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Desktop slider — Brochure ── */
function BrochureDesktop({ products }) {
  const [active, setActive] = useState(0);
  const p = products[active];
  const prev = () => setActive((i) => (i === 0 ? products.length - 1 : i - 1));
  const next = () => setActive((i) => (i === products.length - 1 ? 0 : i + 1));

  return (
    <div className="pg-desktop">
      <button className="pg-arrow pg-arrow--left" onClick={prev} aria-label="Previous">&#8249;</button>
      <div className="pg-slide" key={p.id} style={{ '--accent': p.accent, '--accent-light': p.accentLight, '--accent-border': p.accentBorder }}>
        <div className="pg-image-panel">
          <img src={p.image} alt={p.name} />
          <div className="pg-image-label" style={{ background: `linear-gradient(transparent, ${p.accent}dd)` }}>
            <span className="pg-emoji">{p.emoji}</span>
            <div>
              <h2>{p.name}</h2>
              <p>{p.volume}</p>
            </div>
          </div>
        </div>
        <div className="pg-content-panel">
          <div className="pg-content-inner">
            <div className="pg-plant-title" style={{ borderColor: p.accentBorder }}>
              <div className="pg-title-badge" style={{ background: p.accentLight, border: `2px solid ${p.accentBorder}` }}>
                <span className="pg-emoji">{p.emoji}</span>
              </div>
              <div>
                <h2 style={{ color: p.accent }}>{p.name}</h2>
                <span className="pg-focus-tag" style={{ background: p.accentLight, color: p.accent, border: `1px solid ${p.accentBorder}` }}>
                  🎯 {p.focus}
                </span>
              </div>
            </div>
            <div className="br-points-grid">
              {p.points.map((pt, i) => (
                <div className="br-point" key={i} style={{ borderLeft: `3px solid ${p.accent}` }}>
                  <strong style={{ color: p.accent }}>{pt.title}</strong>
                  <p>{pt.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <button className="pg-arrow pg-arrow--right" onClick={next} aria-label="Next">&#8250;</button>
      <div className="pg-dots">
        {products.map((prod, i) => (
          <button
            key={i}
            className={`pg-dot ${i === active ? 'pg-dot--active' : ''}`}
            style={i === active ? { background: prod.accent, borderColor: prod.accent, width: 28 } : { borderColor: prod.accent }}
            onClick={() => setActive(i)}
            aria-label={prod.name}
          />
        ))}
      </div>
    </div>
  );
}

/* ── Desktop slider — Herbs ── */
function HerbDesktop({ plants }) {
  const [active, setActive] = useState(0);
  const plant = plants[active];
  const prev = () => setActive((i) => (i === 0 ? plants.length - 1 : i - 1));
  const next = () => setActive((i) => (i === plants.length - 1 ? 0 : i + 1));

  return (
    <div className="pg-desktop">
      <button className="pg-arrow pg-arrow--left" onClick={prev} aria-label="Previous">&#8249;</button>
      <div className="pg-slide" key={plant.id}>
        <div className="pg-image-panel">
          <img src={plant.image} alt={plant.name} />
          <div className="pg-image-label">
            <span className="pg-emoji">{plant.emoji}</span>
            <div>
              <h2>{plant.name}</h2>
              <p>{plant.localName}</p>
            </div>
          </div>
        </div>
        <div className="pg-content-panel">
          <div className="pg-content-inner">
            <div className="pg-plant-title">
              <div className="pg-title-badge">
                <span className="pg-emoji">{plant.emoji}</span>
              </div>
              <div>
                <h2>{plant.name}</h2>
                <span>{plant.localName}</span>
              </div>
            </div>
            <div className="pg-section">
              <h3>✅ {plant.lang === 'te' ? 'ఫాయిదాలు' : 'Benefits'}</h3>
              <ul>{plant.benefits.map((b, i) => <li key={i}>{b}</li>)}</ul>
            </div>
            <div className="pg-section">
              <h3>💊 {plant.lang === 'te' ? 'ఎలా ఉపయోగించాలి' : 'How to Use'}</h3>
              <ul>{plant.uses.map((u, i) => <li key={i}>{u}</li>)}</ul>
            </div>
            <div className="pg-section pg-bio">
              <h3>🔬 {plant.lang === 'te' ? 'జీవశాస్త్ర సమాచారం' : 'Biological Information'}</h3>
              <div className="pg-bio-grid">
                <div><span>{plant.lang === 'te' ? 'శాస్త్రీయ పేరు' : 'Scientific Name'}</span><strong><em>{plant.bioInfo.scientificName}</em></strong></div>
                <div><span>{plant.lang === 'te' ? 'కుటుంబం' : 'Family'}</span><strong>{plant.bioInfo.family}</strong></div>
                <div><span>{plant.lang === 'te' ? 'మూలం' : 'Origin'}</span><strong>{plant.bioInfo.origin}</strong></div>
                <div><span>{plant.lang === 'te' ? 'రకం' : 'Type'}</span><strong>{plant.bioInfo.type}</strong></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button className="pg-arrow pg-arrow--right" onClick={next} aria-label="Next">&#8250;</button>
      <div className="pg-dots">
        {plants.map((_, i) => (
          <button
            key={i}
            className={`pg-dot ${i === active ? 'pg-dot--active' : ''}`}
            onClick={() => setActive(i)}
            aria-label={`Plant ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function PlantGallery() {
  const [lang, setLang] = useState('en');

  return (
    <div className="plant-gallery-page">

      {/* ══ SECTION 1 — PRODUCT BROCHURE ══ */}
      <div className="pg-section-block">
        <div className="pg-section-header">
          <div className="pg-section-tag">{lang === 'te' ? 'మా ఉత్పత్తులు' : 'Our Products'}</div>
          <h1>🧪 {lang === 'te' ? 'బ్రోషర్' : 'Product Science Brochure'}</h1>
          <p>{lang === 'te' ? 'ప్రతి బాటిల్ వెనుక ఉన్న జీవశాస్త్రం — మీ ఆరోగ్యం కోసం రూపొందించబడింది, ప్రకృతి చేత మద్దతు పొందింది' : 'The biology behind every bottle — crafted for your health, backed by nature'}</p>
        </div>
        <button
          className="lang-toggle"
          onClick={() => setLang(lang === 'en' ? 'te' : 'en')}
        >
          {lang === 'en' ? '🇮🇳 తెలుగు' : '🇬🇧 English'}
        </button>
        <BrochureDesktop products={lang === 'en' ? productsEn : productsTe} />
        <div className="pg-mobile acc-list">
          {(lang === 'en' ? productsEn : productsTe).map((p) => (
            <AccordionCard key={p.id} item={p} isProduct={true} />
          ))}
        </div>
      </div>

      {/* ══ DIVIDER ══ */}
      <div className="pg-divider">
        <span>🌿 {lang === 'te' ? 'ఆకులు | మూలికలు' : 'Herb Library'}</span>
      </div>

      {/* ══ SECTION 2 — HERB LIBRARY ══ */}
      <div className="pg-section-block">
        <HerbDesktop plants={(lang === 'te' ? plantsTe : plantsEn).map(p => ({ ...p, lang }))} />
        <div className="pg-mobile acc-list">
          {(lang === 'te' ? plantsTe : plantsEn).map((p) => (
            <AccordionCard key={p.id} item={{ ...p, lang }} isProduct={false} />
          ))}
        </div>
      </div>

    </div>
  );
}
